import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';

const initialState = {
  enabled: true
};

export const NavBarStateStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    enable() {
      patchState(store, {enabled: true});
    },
    disable() {
      patchState(store, {enabled: false});
    }
  })
));
